import * as v from "valibot";
import { BaseRecordSchema, baseVals, defineValidation } from "../../common/validation.common";
import { DisbursementBankCodeEnum } from "../../data/enums";
import { GatewayProviderEnum } from "../../data/enums/gateway_provider.enum";

export namespace SystemDisbursementValidation {
    export const Record = defineValidation(BaseRecordSchema);

    export const Create = defineValidation(
        v.object({
            source: v.picklist(GatewayProviderEnum.values),
            bankCode: v.picklist(DisbursementBankCodeEnum.values),
            accountHolder: baseVals.string(),
            accountNumber: baseVals.string(),
            amount: baseVals.intMin(10_000, "Jumlah"),
            otp: v.optional(baseVals.string()),
        }),
    );

    export const CalculateFee = defineValidation(
        v.object({
            amount: baseVals.intMin(0, "Jumlah"),
        }),
    );
}
